import { SortEvent } from 'primeng/api';


export abstract class UiUtils {
    static readonly errorsDict: Record<string, string> = {
        "ERROR_MISSING_NAME": "Name is required.",
        "ERROR_MISSING_ADDRESS": "Address is required.",
        "ERROR_MISSING_CITY": "City is required.",
        "ERROR_MISSING_STATE": "State is required.",
        "ERROR_MISSING_ZIP": "ZIP code is required.",
        "ERROR_MISSING_LICENSE_NUMBER": "License number is required.",
        "ERROR_MISSING_LICENSE_IMAGE": "License image is required.",
        "ERROR_LICENSE_EXPIRED": "License has expired.",
        "WARNING_LICENSE_EXPIRES_IN_30_DAYS": "License expires within 30 days.",
        "ERROR_MISSING_VALID_CONTACT": "A valid contact is required."
    }
    static readonly timeZones = [
        {fullName: 'Pacific Standard Time', id: 'PST'},
        {fullName: 'Central Standard Time', id: 'CST'},
        {fullName: 'Eastern Standard Time', id: 'EST'},
        {fullName: 'Mountain Standard Time', id: 'MST'}
    ]
    // static navbarIsEnabled(isEnabled: boolean)
    // {
    //     if (isEnabled)
    //     {
    //         document.getElementById('header-disable-overlay').style.display = 'none';
    //         return;
    //     }
    //     document.getElementById('header-disable-overlay').style.display = 'block';
    // }

    static getLocale(currencyCode: string): string {
        if(['USD', 'MXN', 'SAR', 'CAR'].includes(currencyCode))
            return 'en-US';
        if(currencyCode == 'EUR')
            return 'de-DE';
        if(currencyCode == 'GBP')
            return 'en-GB';
        if(currencyCode == 'PLN')
            return 'pl-PL';
        return 'en-US';
    }
    static defaultTableSort(event: SortEvent): void
    {
        event.data.sort((data1, data2) => {
            const value1 = data1[event.field];
            const value2 = data2[event.field];
            const result = value1 == null && value2 != null ? -1 :
                (value1 != null && value2 == null) ? 1 :
                    (value1 == null && value2 == null) ? 0 :
                        (typeof value1 === 'string' && typeof value2 === 'string') ? value1.localeCompare(value2) :
                            value1 - value2;
            return event.order * result;
        });
    }

    static convertToKg(value: any)
    {
        let converter =  0.4535;
        value = Math.round((value * converter) * 100) / 100;
        value = parseFloat(value).toFixed(2);
        return value;
    }
}
